import React, { useEffect, useState } from "react";
import "./index.css";
import { MediaRow } from "../../../pages/NewsRoom";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase/config";

function MediaCards() {
  const [mediaArticles, setMediaArticles] = useState([]);

  useEffect(() => {
    return onSnapshot(collection(db, "mediaArticles"), (snap) => {
      setMediaArticles(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
  }, []);

  useEffect(() => {
    const aosElements = document.querySelectorAll(".aosAnim");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("ltr");
        });
      },
      { threshold: 0.3 }
    );
    aosElements.forEach((el) => observer.observe(el));
    return () => aosElements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div
      className="mediaSectionWrap animated-section section aosAnim"
      id="sec17"
    >
      <div className="scrollSection">
        <div className="container">
          <div className="mediaRow">
            <h2 className="titleText" style={{ lineHeight: "1.2" }}>
              Our <span className="skyText">Media</span> Moments!
            </h2>
            <MediaRow articles={mediaArticles} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MediaCards;
